import { getBusinessUnitFilteredOptions } from "helpers";
import { businessUnitsDdl } from "mappers";

const loadOptions = async search => {
	try {
		let options = await businessUnitsDdl;

		let filteredOptions = getBusinessUnitFilteredOptions(options, search);

		return {
			options: filteredOptions,
			hasMore: false,
		};
	} catch {
		return { options: [] };
	}
};

const businessUnitColumn = () => ({
	name: "businessUnit",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option,
	placeholder: "Business Unit",
	isSubOption: data => !!data.parent,
	formatLabel: v =>
		v.parent
			? `${v.parent?.displayName} - ${v.displayName}`
			: v.displayName,
});

export default businessUnitColumn;
